import { useState, useCallback } from 'react'
import { ToastMessage } from '../components/ui/Toast'

export const useToast = () => {
  const [messages, setMessages] = useState<ToastMessage[]>([])

  const showToast = useCallback((
    type: ToastMessage['type'],
    title: string,
    message?: string,
    duration?: number
  ) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9)
    const newMessage: ToastMessage = {
      id,
      type,
      title,
      message,
      duration
    }

    setMessages(prev => [...prev, newMessage])
    return id
  }, [])

  const removeToast = useCallback((id: string) => {
    setMessages(prev => prev.filter(message => message.id !== id))
  }, [])

  const showSuccess = useCallback((title: string, message?: string, duration?: number) => {
    return showToast('success', title, message, duration)
  }, [showToast])

  const showError = useCallback((title: string, message?: string, duration?: number) => {
    return showToast('error', title, message, duration)
  }, [showToast])

  const showInfo = useCallback((title: string, message?: string, duration?: number) => {
    return showToast('info', title, message, duration)
  }, [showToast])

  return {
    messages,
    showToast,
    showSuccess,
    showError,
    showInfo,
    removeToast
  }
}